<template>
  <span>{{ label }}: <DiceBar :dice="dice"></DiceBar></span>
</template>

<script>
import DiceBar from "./DiceBar";
export default {
  name: "DiceItem",
  components: { DiceBar },
  props: {
    label: {
      type: String,
      required: true
    },
    dice: {
      type: Object,
      required: true
    }
  }
};
</script>
